export default __webpack_public_path__ + "static/media/VectorDown.b354e317.svg";